import { graphql } from 'gatsby';
import { Tag } from '@ahaui/react';
import ComponentApi from 'src/components/ComponentApi';
import CodeView from 'src/components/CodeView';
import tagRemove from 'src/examples/Tag/remove';
import tagSubtle from 'src/examples/Tag/subtle';
import tagBold from 'src/examples/Tag/bold';
import * as React from 'react';
export default {
  graphql,
  Tag,
  ComponentApi,
  CodeView,
  tagRemove,
  tagSubtle,
  tagBold,
  React
};